import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Tabs,
  Tab
} from '@material-ui/core';
import { TabPanel, TabContext } from '@material-ui/lab';
import clsx from 'clsx';
import { Breadcrumb, BackdropCircular } from 'components';
import {
  getUserProfileAPI
} from 'api';
import SubscriptionPlans from '../core_configs/SubscriptionPlans';
import GeneralTab from './GeneralTab';
import UserCreditCards from './UserCreditCards';


const useStyles = makeStyles(() => ({
  customBorder: {
    borderBottom: '1px solid rgba(189, 189, 189, 0.5)'
  },
  pointBalance: {
    fontSize: '32px'
  },
  cardBackground: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)'
  }
}));


export default function MyAccount() {
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const tabValue = location.hash || '#general';

  const {profile, loadingProfile} = useSelector((state: IReduxState) => state.user);
  const permissions = profile?.config?.permissions || {};

  useEffect(() => {
    getUserProfileAPI({dispatch});
  }, []);

  const handleTabChange = (_, newValue) =>  history.push(newValue);

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'My Account' }
          ]}
        />
      </div>
      <TabContext value={tabValue == '' ? '#general' : tabValue}>
        <Tabs
          value={tabValue == '' ? '#general' : tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          className={clsx('mx-10', classes.customBorder)}
        >
          <Tab className="capitalize font-medium" value="#general" label="General" />
          {permissions?.profilePayment &&
            <Tab className="capitalize font-medium" value="#payments" label="Payments" />
          }
          {permissions?.profilePayment &&
            <Tab className="capitalize font-medium" value="#payment_options" label="Payment Options" />
          }
        </Tabs>
        <TabPanel value="#general">
          <GeneralTab />
        </TabPanel>
        {permissions?.profilePayment &&
          <TabPanel value="#payments">
            <UserCreditCards />
          </TabPanel>
        }
        {permissions?.profilePayment &&
          <TabPanel value="#payment_options">
            <SubscriptionPlans />
          </TabPanel>
        }
      </TabContext>
      <BackdropCircular loading={loadingProfile} />
    </div>
  );
}
